export default {
  props: {
    opened: {
      required: true,
      type: Boolean,
    }
  },
  computed: {
    dialog: {
      get () {
        return this.opened
      },
      set () {
        this.close()
      }
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
